export enum Colors {
  LIGHT_GREEN = "#A0D568",
  BLUE = "#4173BC",
  LIGHT_BLUE = "#4c81e09c",
  RED = "#d80125",
}
